import PaymentAPI from "../api/payment";
import SettlementAPI from "../api/settlement";
import Vue from 'vue'
import i18n from "../main";
import { concat } from "lodash";

export const payments = {
    state: {
        payments: [],
        paymentOptions:{
            lineCount:0,
            showDeleted:false,
            orderBy:'id',
            orderDirection:'desc',
            itemsPerPage:15,
            itemAdded:false,
            itemSearched:false,
            selectedDay:undefined,
            selectedType:['KP','KW']
        },
        paymentsLoadStatus: 0,
        paymentAddStatus: 0,
        paymentAddText: "",

        paymentEdit: {
            id: undefined,
            lp: 0,
            child:{id:undefined},
            document_number:'',
            type:'KP',
            amount:'',
            created_by:'',
            created_at:'',
            settlements:[],
            selectedSettlements:[],
            selected:[],
            documents:[],
            date:undefined,
            orig_document_number:undefined,
            source:{import_list:[],import_index:-1}
        },

        paymentEditDefault: {
            id: undefined,
            lp: 0,
            child:{id:undefined},
            document_number:'',
            type:'KP',
            amount:'',
            created_by:'',
            created_at:'',
            settlements:[],
            selectedSettlements:[],
            selected:[],
            documents:[],
            date:undefined,
            orig_document_number:undefined,
            source:{import_list:[],import_index:-1}
        },

        paymentEditLoadStatus: 0,
        paymentEditStatus: 0,
        paymentEditText: "",

        paymentDeleteStatus: 0,
        paymentDeleteText: "",

        paymentSendDocumentStatus:0,

    },

    actions: {
        loadPayments({ state, commit, dispatch }) {
            commit("setPayments", []);
            commit("setPaymentsLoadStatus", 1);
                PaymentAPI.getPayments({
                    offset:0,
                    itemsPerPage:state.paymentOptions.itemsPerPage, 
                    orderBy:state.paymentOptions.orderBy,
                    orderDirection:state.paymentOptions.orderDirection,
                    showDeleted:state.paymentOptions.showDeleted,
                    selectedDay:state.paymentOptions.selectedDay,
                    selectedType:state.paymentOptions.selectedType
                })
                .then(function(response) {
                    commit("setOptionsItemAddedAndSearchedFalse");
                    commit("setPaymentLineCount", response.data.lineCount);
                    commit("setPayments", response.data.payments);
                    dispatch("applyIndexOnPayments");
                    commit("setPaymentsLoadStatus", 2);
                })
                .catch(function() {
                    commit("setPayments", []);
                    commit("setPaymentsLoadStatus", 3);
                });
         
        },
        loadMorePayments({ state, commit, dispatch }) {
            commit("setPaymentsLoadStatus", 1);
                PaymentAPI.getPayments({
                    offset:state.payments.length,
                    itemsPerPage:state.paymentOptions.itemsPerPage, 
                    orderBy:state.paymentOptions.orderBy,
                    orderDirection:state.paymentOptions.orderDirection,
                    showDeleted:state.paymentOptions.showDeleted,
                    selectedDay:state.paymentOptions.selectedDay,
                    selectedType:state.paymentOptions.selectedType
                })
                .then(function(response) {
                    commit("setPaymentLineCount", response.data.lineCount);
                    commit("setPayments", _.concat(state.payments, response.data.payments));
                    dispatch("applyIndexOnPayments");
                    commit("setPaymentsLoadStatus", 2);
                })
                .catch(function() {
                    commit("setPayments", []);
                    commit("setPaymentsLoadStatus", 3);
                });
         
        },
        searchPayments({ state, commit, dispatch },data) {
            commit("setPaymentsLoadStatus", 1);
                PaymentAPI.searchPayments({
                    showDeleted:state.paymentOptions.showDeleted,
                    selectedDay:state.paymentOptions.selectedDay,
                    selectedType:state.paymentOptions.selectedType,
                    filterableHeaders:data.filterableHeaders,
                    q:data.q
                })
                .then(function(response) {
                    commit("setOptionsItemAddedAndSearchedFalse");
                    commit("setPaymentSearchedTrue");
                    commit("setPaymentLineCount", response.data.lineCount);
                    commit("setPayments", response.data.payments);
                    dispatch("applyIndexOnPayments");
                    commit("setPaymentsLoadStatus", 2);
                })
                .catch(function() {
                    commit("setPayments", []);
                    commit("setPaymentsLoadStatus", 3);
                });
         
        },
        setPaymentOptions({ state, commit, dispatch },data){
            commit("setPaymentOptions",data.options);
            dispatch("loadPayments");
        },
        applyIndexOnPayments({ commit, state, rootState }) {
            let localPayments = state.payments;

            var i = 1;
            localPayments.forEach(payment => {
                 if(Vue._.isNumber(payment.status)){
                     payment.status = Vue._.find(rootState.lookups.paymentsStatus, { 'value': payment.status }).text;
                 }
                payment.lp = i;
                i++;
            });

            commit("setPayments",localPayments);
        },

        loadSettlementsForChild({ commit },data) {
            commit("setSettlementsForChild", []);
            //commit("setSelectedForChild", []);
            //if(!data.child_id)return;
            
            commit("setSettlementsLoadStatus", 1);
                SettlementAPI.getSettlementsForChild({
                    child_id:data.child_id,
                    document_id:data.document_id,
                    type:data.type
                })
                .then(function(response) {
                    if(data.type=='WB')commit("setSettlementsForChildWB", response.data);
                    else commit("setSettlementsForChild", response.data);
                    commit("setSettlementsLoadStatus", 2);
                })
                .catch(function() {
                    if(data.type=='WB')commit("setSettlementsForChildWB", []);
                    else commit("setSettlementsForChild", []);
                    commit("setSettlementsLoadStatus", 3);
                });
         
        },
        appendSettlementsForChild({ commit },data) {
            commit("setSettlementsLoadStatus", 1);
                SettlementAPI.getSettlementsForChild({
                    child_id:data.child_id,
                    document_id:data.document_id,
                    type:data.type
                })
                .then(function(response) {
                    commit("setSettlementsForChildWB", response.data);
                    commit("setSettlementsLoadStatus", 2);
                })
                .catch(function() {
                    commit("setSettlementsLoadStatus", 3);
                });
        },
        appendSettlementsForBank({ commit },data) {
            commit("setSettlementsLoadStatus", 1);
            commit("setSettlementsAppendStatus", 1);
                SettlementAPI.getSettlementsForBank({
                    bank:data.bank
                })
                .then(function(response) {
                    commit("setSettlementsForChildWB", response.data);
                    commit("setSettlementsLoadStatus", 2);
                    commit("setSettlementsAppendStatus", 2);
                })
                .catch(function() {
                    commit("setSettlementsLoadStatus", 3);
                    commit("setSettlementsAppendStatus", 3);
                });
         
        },
        loadRemoveFromSelected({ commit,dispatch,state },data){
            commit('setRemoveFromSelected',data.settlement);
            if(data.settlement.child.id==state.paymentEdit.child.id){
                dispatch('loadSettlementsForChild',{
                    child_id:data.settlement.child.id,
                    document_id:state.paymentEdit.id,
                    type:'WB'});
            }
        },
        // loadSettlementsForChildWB({ commit },data) {
        //     commit("setSettlementsForChild", []);
        //     //commit("setSelectedForChild", []);
        //     //if(!data.child_id)return;
            
        //     commit("setSettlementsLoadStatus", 1);
        //         SettlementAPI.getSettlementsForChild({
        //             child_id:data.child_id,
        //             document_id:data.document_id,
        //             type:data.type
        //         })
        //         .then(function(response) {
        //             commit("setSettlementsForChild", response.data);
        //             commit("setSettlementsLoadStatus", 2);
        //         })
        //         .catch(function() {
        //             commit("setSettlementsForChild", []);
        //             commit("setSettlementsLoadStatus", 3);
        //         });
         
        // },
        loadDocumentsForDay({ commit },data) {
            commit("setPaymentEditLoadStatus", 1);
            commit("setPaymentEditStatus", 0);
            commit("setPaymentEditText", "");
            commit("setDocumentsForDay", {documents:[],documents_date:[]});
            
            PaymentAPI.getDocumentsForDay()
                .then(function(response) {
                    commit("setDocumentsForDay", response.data);
                    commit("setPaymentEditLoadStatus", 2);
                })
                .catch(function(error) {
                    commit('setPaymentEditText',error.response.data.error);
                    commit("setDocumentsForDay", {documents:[],documents_date:[]});
                    commit("setPaymentEditLoadStatus", 3);
                });
         
        },
        addDocument({ commit, state, dispatch }, data) {
            commit("setPaymentAddStatus", 1);
            commit("setPaymentAddText", "");

            PaymentAPI.postAddNewDocument(
                data.type,
                data.child_id,
                data.amount,
                data.selected,
                data.date,
                data.orig_document_number,
                data.source
            )
                .then(function(response) {
                    commit("setPaymentAddStatus", 2);
                    //commit("setPaymentEdit", response.data);
                    dispatch("loadDocumentEdit",{slug:response.data.id});
                    commit("setAddedPayment",response.data);
                    commit("setPaymentLineCount", state.paymentOptions.lineCount + 1);
                    dispatch("applyIndexOnPayments");
                })
                .catch(function(error) {
                    commit("setPaymentAddStatus", 3);
                    commit("setPaymentAddText", error.response.data.errors);
                });
        },
        loadDocumentEdit({ commit,dispatch }, data) {
            commit("setPaymentEditLoadStatus", 1);
            commit("setPaymentEditStatus", 0);
            commit("setPaymentEditText", "");

            PaymentAPI.getDocumentEdit(data.slug)
                .then(function(response) {
                    commit("setPaymentEdit", response.data);
                    if((response.data.type=='KP' || response.data.type=='KW') && response.data.status==5){
                        dispatch('loadSettlementsForChild', {child_id:response.data.child.id,document_id:response.data.id,type:response.data.type});
                    }
                    commit("setPaymentEditLoadStatus", 2);
                })
                .catch(function() {
                    commit("setPaymentEdit", {});
                    commit("setPaymentEditLoadStatus", 3);
                });
        },
        sendPaymentDocument({ commit }, data) {
            commit("setPaymentSendDocumentStatus", 0);

            PaymentAPI.postSendDocument(data.child_id,data.owner_id,data.document)
                .then(function() {
                    commit("setPaymentSendDocumentStatus", 2);
                })
                .catch(function() {
                    commit("setPaymentSendDocumentStatus", 3);
                });
        },
        loadPaymentEditDefault({ commit }) {
            commit("setPaymentEditDefault");
        },
        loadPaymentAddDefault({ commit }) {
            commit("setPaymentAddStatus", 0);
            commit("setPaymentAddText", "");
        },
        editDocument({ commit, state, dispatch }, data) {
            commit("setPaymentEditStatus", 1);

            PaymentAPI.putEditDocument(
                data.slug,
                data.type,
                data.child_id,
                data.amount,
                data.selected,
                data.date,
                data.orig_document_number,
                data.source
            )
                .then(function(response) {
                    commit("setPaymentEditStatus", 2);
                    commit("setPaymentEdit", response.data);
                    if((response.data.type=='KP' || response.data.type=='KW') && response.data.status==5){
                        dispatch('loadSettlementsForChild', {child_id:response.data.child.id,document_id:response.data.id,type:response.data.type});
                    }
                    commit("setEditedPayment",response.data)
                    dispatch("applyIndexOnPayments");
                })
                .catch(function(error) {
                    commit("setPaymentEditStatus", 3);
                    commit("setPaymentEditText", error.response.data.errors);
                });
        },
        stornDocument({ commit, state, dispatch }, data) {
            commit("setPaymentEditStatus", 1);

            PaymentAPI.getStornDocument(data.slug)
                .then(function(response) {
                    commit("setPaymentEditStatus", 2);
                    commit("setPaymentEdit", response.data);
                    dispatch('loadSettlementsForChild', {child_id:response.data.child.id,document_id:response.data.id,type:response.data.type});
                    commit("setEditedPayment",response.data)

                    dispatch('loadPayments');
                    //dispatch("applyIndexOnPayments");
                })
                .catch(function(error) {
                    commit("setPaymentEditStatus", 3);
                    commit("setPaymentEditText", error.response.data.errors);
                });
        },
        deleteDocument({ commit, state, dispatch }, data) {
            commit("setPaymentDeleteStatus", 1);

            PaymentAPI.deleteDocument(data.slug)
                .then(function(response) {
                    commit("setPaymentDeleteStatus", 2);
                    if(state.paymentOptions.showDeleted){
                        commit("setEditedPayment",response.data)
                    }else{
                        commit("setPaymentLineCount", state.paymentOptions.lineCount - 1);
                        commit("setDeletedPayment",response.data)
                    }
                    dispatch("applyIndexOnPayments");
                })
                .catch(function() {
                    commit("setPaymentDeleteStatus", 3);
                });
        },
    },
    mutations: {
        setPaymentOptions(state,options){
            state.paymentOptions = options;
        },
        setPaymentsLoadStatus(state, status) {
            state.paymentsLoadStatus = status;
        },
        setPayments(state, payments) {
            state.payments = payments;
        },
        setPaymentLineCount(state, lineCount) {
            state.paymentOptions.lineCount = lineCount;
        },
        setPaymentAddStatus(state, status) {
            state.paymentAddStatus = status;
        },
        setPaymentAddText(state, text) {
            state.paymentAddText = text;
        },
        setPaymentEdit(state, payment) {
            if(payment.type=='WB'){
                payment.settlements = []
                payment.child = {id:undefined}
            }
            state.paymentEdit = payment;
            //state.paymentEdit.amount = i18n.n(state.paymentEdit.amount, 'number', 'pl-PL');
        },
        setEditedPayment(state, payment) {
            var lp = Vue._.find(state.payments,{'id':payment.id}).lp;
            var index = Vue._.findIndex(state.payments,{'id':payment.id});
           
            var p = payment;
            //p.amount = parseFloat(p.amount.toString().replace(',','.'));
            state.payments[index] = p;
            state.payments[index].lp = lp;
        },
        setAddedPayment(state, payment) {
            state.paymentOptions.itemAdded = true;
            var p = payment;
            p.amount = parseFloat(p.amount.toString().replace(',','.'));
            state.payments.push(p);
        },
        setPaymentSearchedTrue(state) {
            state.paymentOptions.itemSearched = true;
        },
        setOptionsItemAddedAndSearchedFalse(state) {
            state.paymentOptions.itemAdded = false;
            state.paymentOptions.itemSearched = false;
        },
        setDeletedPayment(state, payment) {
            var index = Vue._.findIndex(state.payments,{'id':payment.id});
            state.payments.splice(index,1);
        },
        setPaymentEditDefault(state) {
            state.paymentEdit = JSON.parse(JSON.stringify(state.paymentEditDefault));// { ...state.paymentEditDefault };
            //state.paymentEdit.child.id = undefined;
        },
        setPaymentEditStatus(state, status) {
            state.paymentEditStatus = status;
        },
        setPaymentEditText(state, text) {
            state.paymentEditText = text;
        },
        setPaymentEditLoadStatus(state, status) {
            state.paymentEditLoadStatus = status;
        },
        setPaymentDeleteStatus(state, status) {
            state.paymentDeleteStatus = status;
        },
        setPaymentDeletedText(state, text) {
            state.paymentDeleteText = text;
        },
        setSettlementsForChild(state, settlements) {
            state.paymentEdit.settlements = settlements;
        },
        setSettlementsForChildWB(state, settlements) {//uzupełnianie tabelki z rozliczeniami dla dziecka
            state.paymentEdit.settlements =  state.paymentEdit.settlements.concat(settlements);
            //state.paymentEdit.selectedSettkements
            //domyślnie zaznaczone gdy 'WB'
        },
        setSelectedForChild(state, settlements) {
            state.paymentEdit.selected = settlements;
        },
        setDocumentsForDay(state, data) {
            let localDocuments = data.documents;
            var i = 1;
            if(localDocuments){
                localDocuments.forEach(doc => {
                    if(doc.type=='KP'){
                        doc.amountKP = doc.amount
                        doc.amountKW = 0;
                    }
                    else {
                        doc.amountKP = 0;
                        doc.amountKW = doc.amount;
                    }

                    doc.lp = i;
                    i++;
                });
            }
            state.paymentEdit.documents = localDocuments;
            state.paymentEdit.date = data.date;
        },
        setAddToDocument(state, settlement) {
            var index = Vue._.findIndex(state.paymentEdit.settlements,{'id':settlement.id});
            state.paymentEdit.selected.push(settlement);
            state.paymentEdit.settlements.splice(index,1); 
        },
        setAddToSettlement(state, settlement) {
            var index = Vue._.findIndex(state.paymentEdit.selected,{'id':settlement.id});
            state.paymentEdit.settlements.push(settlement);
            state.paymentEdit.selected.splice(index,1); 
        },
        setRemoveFromSelected(state, settlement) {
            var index = Vue._.findIndex(state.paymentEdit.selected,{'id':settlement.id});
            state.paymentEdit.selected.splice(index,1); 
            
        },
        setAddSelectedSettlementsToDocument(state,bank){
            state.paymentEdit.selectedSettlements.forEach(element => {
                //jeżeli już jest taki id w selected to payed się sumują
                element.bank = bank;
                let s = Vue._.find(state.paymentEdit.selected,{'id':element.id});
                if(s && element.payed!=0){
                    s.payed += element.payed;
                }else if(element.payed!=0){
                    state.paymentEdit.selected.push(element);
                }
                // if(s && element.payed>0){
                //     s.payed += element.payed;
                // }else if(element.payed>0){
                //     state.paymentEdit.selected.push(element);
                // }
            });
            state.paymentEdit.settlements = [];
            state.paymentEdit.selectedSettlements = [];
            state.paymentEdit.child.id = undefined;
        },
        setSelectedSettlements(state,settlements){
            state.paymentEdit.selectedSettlements = settlements;
        },
        setRecalculateDocument(state, data){
            var amount = parseFloat(state.paymentEdit.amount.toString().replace(',','.'));
            if(isNaN(amount))amount=0;

            var order_temp = {stay:['payed_stay','fix','hour','posted_stay'],meal:['payed_meal','fix_meal','meal','posted_meal'],other:['payed_other','fix_other','other','posted_other']};
                
            Vue._.orderBy(state.paymentEdit.selected,['year','month']).forEach(element => {
                if(state.paymentEdit.type=='KP'){
                    var toPay = element.amount - element.posted_without_document;
                }else{
                    var toPay = element.posted_without_document;
                }
                
                if(amount>=toPay){
                    element.payed  = toPay;
                    amount = amount - toPay;
                }else if(amount>0){
                    element.payed  = amount;
                    amount = 0;
                }else{
                    element.payed = 0;
                }
                
                //rozbicie patnosci na czynniki w zaleznosci od priorytetow
                var a = element.payed;
                data.user.settings.payment_order.forEach(e => {
                    element[order_temp[e][0]] = (a >= element[order_temp[e][1]] + element[order_temp[e][2]] - element[order_temp[e][3]])?element[order_temp[e][1]] + element[order_temp[e][2]] - element[order_temp[e][3]]:a;
                    a = a -  element[order_temp[e][0]];
                });
                
            });

            //jeżeli coś zostało(nadpłata)
            if(amount>0){
                Vue._.last(Vue._.orderBy(state.paymentEdit.selected,['year','month'])).payed += amount;
                Vue._.last(Vue._.orderBy(state.paymentEdit.selected,['year','month']))[order_temp[data.user.settings.payment_order[0]][0]] += amount;
            }
        },
        setEmptyChild(state){
            state.paymentEdit.settlements = [];
            state.paymentEdit.selectedSettlements = [];
            state.paymentEdit.child.id = undefined;
        },
        setEmptyChildChildId(state){
            //state.paymentEdit.settlements = [];
            //state.paymentEdit.selectedSettlements = [];
            state.paymentEdit.child.id = undefined;
        },
        setChildChildId(state,value){
            state.paymentEdit.child.id = value;
        },
        setPaymentSourceImportList(state,value){
            state.paymentEdit.source.import_list = value;
        },
        setPaymentSourceImportIndex(state,value){
            state.paymentEdit.source.import_index = value;
        },
        setRecalculateSettlement(state,data){
            var amount = parseFloat(data.amount.toString().replace(',','.'));
            if(isNaN(amount))amount=0;

            var order_temp = {stay:['payed_stay','fix','hour','posted_stay'],meal:['payed_meal','fix_meal','meal','posted_meal'],other:['payed_other','fix_other','other','posted_other']};
            
            Vue._.orderBy(state.paymentEdit.settlements,['year','month']).forEach(element => {
                if(!Vue._.find(state.paymentEdit.selectedSettlements,{'id':element.id})){
                    element.payed = 0;
                }else{
                    var toPay = element.amount - element.posted_without_document;
                    
                    if(amount>=toPay){//zostaje > 0
                        element.payed  = toPay;
                        amount = amount - toPay;
                    }else if(amount>0){//nie ma więcej
                        element.payed  = amount;
                        amount = 0;
                    }else{
                        element.payed = 0;
                    }

                    //rozbicie patnosci na czynniki w zaleznosci od priorytetow
                    var a = element.payed;
                    data.user.settings.payment_order.forEach(e => {
                        element[order_temp[e][0]] = (a >= element[order_temp[e][1]] + element[order_temp[e][2]] - element[order_temp[e][3]])?element[order_temp[e][1]] + element[order_temp[e][2]] - element[order_temp[e][3]]:a;
                        a = a -  element[order_temp[e][0]];
                    });
                }
            });

            //jeżeli coś zostało(nadpłata)
            if(amount>0){
                Vue._.last(Vue._.orderBy(state.paymentEdit.selectedSettlements,['year','month'])).payed += amount;
                Vue._.last(Vue._.orderBy(state.paymentEdit.selectedSettlements,['year','month']))[order_temp[data.user.settings.payment_order[0]][0]] += amount;
            }
        },
        setPaymentSendDocumentStatus(state, status) {
            state.paymentSendDocumentStatus = status;
        },
    },

    getters: {
        getPaymentOptions(state){
            return state.paymentOptions;
        },
        getPaymentsLoadStatus(state) {
            return state.paymentsLoadStatus;
        },
        getPayments(state) {
            return state.payments;
        },
        getPaymentAddStatus(state) {
            return function(){
                return state.paymentAddStatus;
            } 
        },
        getPaymentAddText(state) {
            return state.paymentAddText;
        },
        getPaymentEdit(state) {
            return state.paymentEdit;
        },
        getPaymentEditStatus(state) {
          return function(){
            return state.paymentEditStatus;
          }
        },
        getPaymentEditing(state) {
            return state.paymentEdit.id > 0;
        },
        getPaymentEditText(state) {
            return state.paymentEditText;
        },
        getPaymentEditLoadStatus(state) {
            return function(){
                return state.paymentEditLoadStatus;
            }
        },
        getPaymentDeleteStatus(state) {
            return function(){
                return state.paymentDeleteStatus;
            }
        },
        getPaymentSendDocumentStatus(state) {
            return function(){
                return state.paymentSendDocumentStatus;
            }
        },
        getPaymentDeleteText(state) {
            return state.paymentDeleteText;
        },
        getSettlementsForChild(state){
            return state.paymentEdit.settlements;
        },
        getFilteredSettlements(state){
            //if(state.paymentEdit.id)return state.paymentEdit.settlements;

            var localSettlements = [];
            state.paymentEdit.settlements.forEach(s => {
            var element = Vue._.find(state.paymentEdit.selected,{'id':s.id});
                if(!element){
                    localSettlements.push(s);
                }else if(element && element.payed<(s.amount-s.posted_without_document)){
                    s.posted_without_document += element.payed;
                    localSettlements.push(s);
                }
            });
            return localSettlements;
        }
    }
};
